import { Box } from "@mui/system";
import { Typography } from "@mui/material";

import Logo from "../../../assets/images/OutInServiceLoginImage.png";

const textLogoStyles = {
  color: "#000000",
  fontSize: "22px",
  fontWright: "bold",
  marginLeft: "12px",
  marginRight: "12px",
};

const LogoSection = () => {
  return (
    <Box
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
    >
      <img
        src={Logo}
        height={50}
        width={50}
        alt="icons"
        style={{ objectFit: "scale-down" }}
      />
      <Typography sx={{ ...textLogoStyles, mx: 0 }} variant="h2">
        {"OIS"}
      </Typography>
    </Box>
  );
};

export default LogoSection;
